/****************************************************
 * Module Name:  dicumentTypeMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Box, Button, Tooltip } from "@mui/material";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import CircularProgress from "@mui/material/CircularProgress";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";

import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import DocumentTyeProxy from "../../utility/proxy/manager/documentTypeProxy";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import AddDocumentTypeModal from "./addDocumentTypeModal";
import NoPermission from "../common/noPermission";
import PageTitle from "../common/pageTitle";

export class DocumentTypeMaster extends Component {
    constructor(props) {
        super(props);

        this.state = {
            documentTypeData: [],
            editOperation: false,
            sourceData: {},
            errorSnackbar: false,
            showAddDocumentTypeModal: false,
            showLoadSpinner: true,
            local_Permission: Constants.USER_PERMISSION.filter(
                (iPermission) =>
                    iPermission.permissionid === Constants.PERMISSIONS.UTILITY_DOCUMENTTYPE
            ),
        }
        this.fetchDoucmentTypeData(false);
    }

    componentDidMount() {
        PageTitle("UTILITY_DOCUMENTTYPE");
    }

    fetchDoucmentTypeData = (bAnimateSpinner) => {
        bAnimateSpinner && this.setState({ showLoadSpinner: true });
        DocumentTyeProxy.getAllDocumentType((responseData) => {
            if (responseData) {
                this.setState({
                    documentTypeData: responseData,
                    showLoadSpinner: false,
                })
            } else {
                this.setState({
                    errorSnackbar: true,
                    showLoadSpinner: false
                })
            }
        });
    }

    columns = [
        {
            field: "id",
            headerName: "ID",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            field: "type",
            headerName: "TYPE",
            headerAlign: "center",
            align: "center",
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: "description",
            headerName: "DESCRIP",
            headerAlign: "center",
            align: "center",
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: "edit",
            headerName: "EDIT",
            headerAlign: "center",
            align: "center",
            flex: 0.5,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                return (
                    <Box
                        style={{ textAlign: "center", cursor: "pointer" }}
                        onClick={() => {
                            this.setState({
                                showAddDocumentTypeModal: true,
                                editOperation: true,
                                sourceData: params.row,
                            });
                        }}>
                        <BorderColorIcon color="primary" />
                    </Box>
                );
            },
        },
    ]

    handleValidation = (stonestatusData) => {
        //TODO do validation if needed here
        return true;
    };

    hideAddDocumentTypeModal = () => {
        this.setState({
            showAddDocumentTypeModal: false,
        });
    }

    addDocumentType = (documentTypeData) => {
        this.setState({ loadingButton: true });
        if (this.state.editOperation) {
            //Updating DocumentType, and once DocumentType is updated on call refresh the list of current DocumentType
            DocumentTyeProxy.UpdateDocumentType(documentTypeData, (response) => {
                if (response) {
                    this.fetchDoucmentTypeData(true);
                    this.setState({ loadingButton: false });
                    //Hidding Document Type modal
                    this.hideAddDocumentTypeModal();
                } else {
                    this.setState({ errorSnackbar: true });
                    this.setState({ loadingButton: false });
                }
            })
        } else {
            //Creating new DocumentType, and once DocumentType is created on call refresh the list of current DocumentType
            DocumentTyeProxy.AddDocumentType(documentTypeData, (response) => {
                if (response) {
                    this.fetchDoucmentTypeData(true);
                    this.setState({ loadingButton: false });
                    //Hidding Document Type modal
                    this.hideAddDocumentTypeModal();
                } else {
                    this.setState({ errorSnackbar: true });
                    this.setState({ loadingButton: false });
                }
            })
        }
    }

    render() {

        const CustomToolbar = () => {
            return (
                <GridToolbarContainer
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        marginHorizontal: "5px",
                        "&.MuiDataGrid-toolbarContainer": {
                            padding: "0px 4px !important",
                        },
                    }}
                >
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarExport />
                    <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
                    {this.state.showLoadSpinner ? (
                        <CircularProgress size="1rem" />
                    ) : (
                        <Tooltip title="Reload List">
                            <RefreshOutlinedIcon
                                color="primary"
                                fontSize="medium"
                                onClick={() => this.fetchDoucmentTypeData(true)}
                                sx={{ cursor: "pointer" }}
                            />
                        </Tooltip>
                    )}

                    {Utility.isAddAllowed(this.state.local_Permission) ? (
                        <Tooltip title="Add Document Type">
                            <Button
                                color="info"
                                variant="outlined"
                                size="small"
                                sx={{ ml: "5px" }}
                                onClick={() =>
                                    this.setState({
                                        showAddDocumentTypeModal: true,
                                        editOperation: false,
                                        sourceData: {},
                                    })
                                }
                                startIcon={<AddBoxOutlinedIcon size="large" />}
                            >
                                Add Document Type
                            </Button>
                        </Tooltip>
                    ) : null}

                    <GridToolbarQuickFilter debounceMs={500} />
                </GridToolbarContainer>
            );
        }
        let allowed = Utility.isReadAllowed(this.state.local_Permission)
        if (!allowed) {
            return <NoPermission />
        }
        const rows = this.state.documentTypeData;
        const columns = //this.columns
            Utility.isUpdateAllowed(this.state.local_Permission)
                ? this.columns
                : this.columns.filter((col) => col.field !== "edit");

        return (
            <Box>
                <CommonSnackbar
                    show={this.state.errorSnackbar}
                    message={<Box>{Constants.APiFailErrorMessage}</Box>}
                    variant={"error"}
                    autoHide={Constants.SnackBarCloseTimer}
                    handleClose={() => this.setState({ errorSnackbar: false })}
                    title="Failed"
                />

                {this.state.showAddDocumentTypeModal ? (
                    <AddDocumentTypeModal
                        Show={true}
                        handleSave={this.addDocumentType}
                        handleClose={this.hideAddDocumentTypeModal}
                        handleValidation={this.handleValidation}
                        editOperation={this.state.editOperation}
                        sourceData={this.state.sourceData}
                        loading={this.state.loadingButton}
                    />
                ) : <Box />}

                <Box px={1} sx={{ mt: 1 }}>
                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            color: '#000',
                            width: "100%",
                            position: "relative",
                            "& .MuiTablePagination-selectLabel": {
                                marginTop: "15px",
                            },
                            "& .MuiTablePagination-displayedRows": {
                                marginTop: "15px",
                            },
                            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .css-cc8tf1": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            height: "85vh",
                        }}>
                        <DataGridPro
                            disableRowSelectionOnClick={true}
                            getRowHeight={() => "auto"}
                            sx={{
                                '& .MuiDataGrid-columnHeader': {
                                    color: '#fff',
                                    backgroundColor: 'grey',
                                },
                                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                    py: "4px",
                                },
                                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                    py: "12px",
                                },
                                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                    py: "18px",
                                },

                            }}
                            density="compact"
                            slots={{ toolbar: CustomToolbar }}
                            rows={rows}
                            columns={columns}
                            getRowId={(row) => row.id}
                            initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        // Hide columns status and traderName, the other columns will remain visible
                                        id: false,
                                    },
                                },
                                pagination: {
                                    paginationModel: Constants.pageSize,
                                },
                            }}
                            pageSizeOptions={Constants.pageSizeOptions}
                            pagination
                            loading={this.state.showLoadSpinner}
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                },
                            }}
                        />
                    </Box>
                </Box>
            </Box>
        )
    }
}